export const FIRESTORE_ORDERS_COLLECTION = "orders";

export const MAX_NUMBER_OF_ORDER_CONNECTOR_RETRIES = 2;

export const ORDER_SEARCH_FIELDS = ["table_name", "display_id", "customer.first_name", "customer.last_name", "customer.email", "customer.phone"];